import type { IAnalyticsParams } from '../../store/reducers/offers';

interface DecorateLinksParams {
  clickLink?: string;
  displayLink?: string;
  utmParams: IAnalyticsParams['utmParams'];
  isPopup: boolean;
}

export const decorateLinks = ({
  clickLink,
  displayLink,
  utmParams,
  isPopup,
}: DecorateLinksParams): {
  clickLink?: string;
  displayLink?: string;
} => {
  try {
    const clickUrl = new URL(clickLink);
    const displayUrl = new URL(displayLink);

    Object.entries(utmParams).forEach(([key, value]) => {
      let paramValue = value;

      if (key === 'source' && value === 'recommendation' && isPopup) {
        paramValue = `${value}_pop-up`;
      }

      clickUrl && clickUrl.searchParams.set(key, paramValue);
      displayUrl && displayUrl.searchParams.set(key, paramValue);
    });

    return {
      clickLink: clickUrl.toString(),
      displayLink: displayUrl.toString(),
    };
  } catch (error) {
    return { clickLink, displayLink };
  }
};
